/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
    ######   ######  ########   #######  ##       ##
   ##    ## ##    ## ##     ## ##     ## ##       ##
   ##       ##       ##     ## ##     ## ##       ##
    ######  ##       ########  ##     ## ##       ##
         ## ##       ##   ##   ##     ## ##       ##
   ##    ## ##    ## ##    ##  ##     ## ##       ##
    ######   ######  ##     ##  #######  ######## ########
*/
/*
          ##     ## ########    ###    ########  ######## ########
          ##     ## ##        ##   ##  ##     ## ##       ##     ##
  ####### ######### ######   ##     ## ##     ## ######   ########
          ##     ## ##       ######### ##     ## ##       ##   ##
          ##     ## ######## ##     ## ########  ######## ##     ##
*/
if ($('.js-header')[0]) {
  // const header = $('.js-header')
  // if ($(this).scrollTop() > 500) {
  //   header.removeClass('onTop')
  // } else {
  //   header.addClass('onTop')
  // }
  // $(window).on('scroll', function () {
  //   if ($(this).scrollTop() > 500) {
  //     header.removeClass('onTop')
  //   } else {
  //     header.addClass('onTop')
  //   }
  // })
}
/*
          ########  #######  ########
             ##    ##     ## ##     ##
  #######    ##    ##     ## ########
             ##    ##     ## ##
             ##     #######  ##
*/
if ($('.js-topIntro')[0]) {
  const topIntro = $('.js-topIntro')
  $(window).on('scroll', function () {
    if (window.matchMedia('(min-width:769px)').matches) {
      const scrollTop = $(window).scrollTop()
      const bgPosition = scrollTop / 6
      if (bgPosition) {
        topIntro.css('background-position', 'center top -' + bgPosition + 'px')
      }
    } else {
      const scrollTop = $(window).scrollTop()
      if (scrollTop < 500) {
        topIntro.addClass('active')
      }
    }
  })
}
if ($('.js-topWork')[0]) {
  const topWork = $('.js-topWork')
  $(window).on('scroll', function () {
    if (window.matchMedia('(min-width:769px)').matches) {
      const scrollTop = $(window).scrollTop()
      const bgPosition = scrollTop / 6
      if (bgPosition) {
        topWork.css('background-position', ' left -9.5rem bottom -' + bgPosition + 'px')
      }
    }
  })
}

// 仕事を知るすいません一旦ここに置きました
if ($('.js-occupation')[0]) {
  const topWork = $('.js-occupation')
  $(window).on('scroll', function () {
    if (window.matchMedia('(min-width:769px)').matches) {
      const scrollTop = $(window).scrollTop()
      const bgPosition = scrollTop / 8
      if (bgPosition) {
        topWork.css('background-position', ' left -9.5rem bottom -' + bgPosition + 'px')
      }
    }
  })
}

if ($('.js-occupation-reverse')[0]) {
  const topWork = $('.js-occupation-reverse')
  $(window).on('scroll', function () {
    if (window.matchMedia('(min-width:769px)').matches) {
      const scrollTop = $(window).scrollTop()
      const bgPosition = scrollTop / 8
      if (bgPosition) {
        topWork.css('background-position', ' right 9.5rem bottom -' + bgPosition + 'px')
      }
    }
  })
}

/*
          ########  #######  ########  #######  ########
             ##    ##     ##    ##    ##     ## ##     ##
  #######    ##    ##     ##    ##    ##     ## ########
             ##    ##     ##    ##    ##     ## ##
             ##     #######     ##     #######  ##
*/
if ($('.js-toTop')[0]) {
  const toTop = $('.js-toTop')
  if ($(this).scrollTop() > 100) {
    toTop.removeClass('onTop')
  } else {
    toTop.addClass('onTop')
  }
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 100) {
      toTop.removeClass('onTop')
    } else {
      toTop.addClass('onTop')
    }
  })
}

/*
    ######  ##       #### ########  ########
   ##    ## ##        ##  ##     ## ##
   ##       ##        ##  ##     ## ##
    ######  ##        ##  ##     ## ######
         ## ##        ##  ##     ## ##
   ##    ## ##        ##  ##     ## ##
    ######  ######## #### ########  ########
*/
/*
            ##     ## ##     ##
            #### #### ##     ##
    ####### ## ### ## ##     ##
            ##     ##  ##   ##
            ##     ##    ###
*/
// MVスライダー
if ($('.js-topMv')[0]) {
  // eslint-disable-next-line no-unused-vars
  const topMvSlide = new Swiper('.js-topMv', {
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
  })
}
/*
            ##     ## ######## ##     ## ########  ######## ########
            #### #### ##       #### #### ##     ## ##       ##     ##
    ####### ## ### ## ######   ## ### ## ########  ######   ########
            ##     ## ##       ##     ## ##     ## ##       ##   ##
            ##     ## ######## ##     ## ########  ######## ##     ##
*/
/*
let topMemberSlide
if (document.getElementsByClassName('js-topMemberSlide')[0]) {
  // SP時だけスライダーにする

  let topMemberSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    topMemberSlideInit()
    topMemberSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (topMemberSlideActive && window.matchMedia('(min-width:769px)').matches) {
      topMemberSlide.destroy()
      topMemberSlideActive = false
    } else if (!topMemberSlideActive && window.matchMedia('(max-width:768px)').matches) {
      topMemberSlideInit()
      topMemberSlideActive = true
    }
  })
}
function topMemberSlideInit() {
  topMemberSlide = new Swiper('.js-topMemberSlide', {
    centeredSlides: true,
    slidePerView: 1.2,
    spaceBetween: 12,
    loop: true,
    navigation: {
      nextEl: '.js-topMemberSlide-next',
      prevEl: '.js-topMemberSlide-prev',
    },
  })
}
*/
//常にスライダー
if ($('.js-topMemberSlide')[0]) {
  // eslint-disable-next-line no-unused-vars
  const topMemberSlide = new Swiper('.js-topMemberSlide', {
    centeredSlides: true,
    slidePerView: 1.2,
    spaceBetween: 12,
    breakpoints: {
      // 768px以上の場合
      768: {
        centeredSlides: false,
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
    loop: true,
    navigation: {
      nextEl: '.js-topMemberSlide-next',
      prevEl: '.js-topMemberSlide-prev',
    },
  })
}

/*
          #### ##    ## ######## ######## ########  ##     ## #### ######## ##      ##
           ##  ####  ##    ##    ##       ##     ## ##     ##  ##  ##       ##  ##  ##
  #######  ##  ## ## ##    ##    ######   ########  ##     ##  ##  ######   ##  ##  ##
           ##  ##  ####    ##    ##       ##   ##    ##   ##   ##  ##       ##  ##  ##
          #### ##    ##    ##    ######## ##     ##    ###    #### ########  ###  ###
*/
let interviewOtherSlide
if (document.getElementsByClassName('js-interviewOtherSlide')[0]) {
  // SP時だけスライダーにする
  let interviewOtherSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    interviewOtherSlideInit()
    interviewOtherSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (interviewOtherSlideActive && window.matchMedia('(min-width:769px)').matches) {
      interviewOtherSlide.destroy()
      interviewOtherSlideActive = false
    } else if (!interviewOtherSlideActive && window.matchMedia('(max-width:768px)').matches) {
      interviewOtherSlideInit()
      interviewOtherSlideActive = true
    }
  })
}
function interviewOtherSlideInit() {
  interviewOtherSlide = new Swiper('.js-interviewOtherSlide', {
    centeredSlides: true,
    slidePerView: 1.2,
    spaceBetween: 12,
    loop: true,
    navigation: {
      nextEl: '.js-interviewOtherSlide-next',
      prevEl: '.js-interviewOtherSlide-prev',
    },
  })
}

/*
          ##      ##  #######  ########  ##    ##
          ##  ##  ## ##     ## ##     ## ##  ##
  ####### ##  ##  ## ##     ## ########  #####
          ##  ##  ## ##     ## ##   ##   ##  ##
           ###  ###   #######  ##     ## ##    ##
*/

let workOccupationInterviewSlide
if (document.getElementsByClassName('js-workOccupationInterviewSlide')[0]) {
  // SP時だけスライダーにする
  let workOccupationInterviewSlideActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    workOccupationInterviewSlideInit()
    workOccupationInterviewSlideActive = true
  }
  window.addEventListener('resize', function (e) {
    if (workOccupationInterviewSlideActive && window.matchMedia('(min-width:769px)').matches) {
      workOccupationInterviewSlide.destroy()
      workOccupationInterviewSlideActive = false
    } else if (!workOccupationInterviewSlideActive && window.matchMedia('(max-width:768px)').matches) {
      workOccupationInterviewSlideInit()
      workOccupationInterviewSlideActive = true
    }
  })
}
function workOccupationInterviewSlideInit() {
  workOccupationInterviewSlide = new Swiper('.js-workOccupationInterviewSlide', {
    centeredSlides: true,
    slidePerView: 1.2,
    spaceBetween: 12,
    loop: true,
    navigation: {
      nextEl: '.js-workOccupationInterviewSlide-next',
      prevEl: '.js-workOccupationInterviewSlide-prev',
    },
  })
}

/*
  ########  #######  ########
     ##    ##     ## ##     ##
     ##    ##     ## ########
     ##    ##     ## ##
     ##     #######  ##
*/
if ($('.js-topMvText')[0]) {
  $('.js-topMvText').each(function () {
    const elemPos = $(this).offset().top - 50
    const scroll = $(window).scrollTop()
    const windowHeight = $(window).height()
    if (scroll >= elemPos - windowHeight) {
      $(this).addClass('active')
    } else {
      $(this).removeClass('active')
    }
  })
}

/*
  ##      ##  #######  ########  ##    ##
  ##  ##  ## ##     ## ##     ## ##  ##
  ##  ##  ## ##     ## ########  #####
  ##  ##  ## ##     ## ##   ##   ##  ##
   ###  ###   #######  ##     ## ##    ##
*/
// 向いています
$('.js-workOccupationSuitableItem').on('click', function () {
  if (window.matchMedia('(max-width:768px)').matches) {
    $(this).toggleClass('active')
    $(this).next().slideToggle()
  }
})
// 仕事内容
$('.js-workOccupationWorkNav').on('click', function () {
  if (!$(this).hasClass('show')) {
    const workOccupationWork = $(this).attr('data-work')

    // 選択ボタン
    $('.js-workOccupationWorkNav').removeClass('show')
    $(this).addClass('show')

    // 詳細
    $('.js-workOccupationWork').removeClass('show')
    $('.js-workOccupationWork-' + workOccupationWork).addClass('show')
  }
})

/*
  #### ##    ## ######## ######## ########  ##     ## #### ######## ##      ##
   ##  ####  ##    ##    ##       ##     ## ##     ##  ##  ##       ##  ##  ##
   ##  ## ## ##    ##    ######   ########  ##     ##  ##  ######   ##  ##  ##
   ##  ##  ####    ##    ##       ##   ##    ##   ##   ##  ##       ##  ##  ##
  #### ##    ##    ##    ######## ##     ##    ###    #### ########  ###  ###
*/
$('.js-memberNav').on('click', function () {
  const sort = $(this).attr('data-sort')
  $('.js-memberNav').removeClass('active')
  $(this).addClass('active')
  if (sort === 'all') {
    $('.js-member-sort').removeClass('hidden')
  } else {
    $('.js-member-sort').addClass('hidden')
    $('.js-member-' + sort).removeClass('hidden')
  }
})

$('.js-interviewRoutineNav').on('click', function () {
  const tab = $(this).attr('data-tab')
  $('.js-interviewRoutine').removeClass('active')
  $('#' + tab).addClass('active')
  $(this).siblings().removeClass('active')
  $(this).addClass('active')
})

/*
  ######## ##    ## ######## ########  ##    ##
  ##       ####  ##    ##    ##     ##  ##  ##
  ######   ## ## ##    ##    ########     ##
  ##       ##  ####    ##    ##   ##      ##
  ######## ##    ##    ##    ##     ##    ##
*/
if ($('.js-entry')[0]) {
  const param = getParam('entry')
  if (param === 'sales') {
    $('option[value="営業職"]').prop('selected', true)
  } else if (param === 'office') {
    $('option[value="事務職"]').prop('selected', true)
  } else if (param === 'part') {
    $('option[value="事務職(パート・アルバイト)"]').prop('selected', true)
  }
}
function getParam(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

/*
        ##  ######          #### ##    ##
        ## ##                ##  ####  ##
        ##  ######  #######  ##  ## ## ##
  ##    ##       ##          ##  ##  ####
   ######   ######          #### ##    ##
*/
if (document.getElementsByClassName('js-in')[0]) {
  // 画面に入った監視対象に.animatedを付加
  // Intersection Observer
  intObs()
}
function intObs() {
  let rootMargin = '-10px 0px'
  if (window.matchMedia('(max-width:768px)').matches) {
    //SPは検出を早くする
    rootMargin = '100px 0px'
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('active')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
